import PropTypes from 'prop-types'
import React from 'react'
import { TextField, SelectField, MenuItem, FlatButton } from 'material-ui'
import styles from './callLogPopover.css'
import { choosePhoneNumberFormatter } from '../../../services/formatters'

const ContactInfoForm = ({
  newContactInfo: {
    firstName,
    lastName,
    email,
    phoneNumber,
    attribution,
    otherAttribution,
  },
  onChangeContactInfo,
  onDropdownSelect,
  onDiscardClick,
  onSaveClick,
}) => {
  const formatPhoneNumberUS = choosePhoneNumberFormatter('US')
  const validForm = firstName && lastName && email && phoneNumber

  return (
    <div className={styles.popover}>
      <p>Enter Contact Information</p>
      <div className={styles.actionsRow}>
        <TextField
          id="firstName"
          floatingLabelText="First Name"
          floatingLabelFixed
          onChange={e => onChangeContactInfo('firstName', e)}
          value={firstName}
          style={{ width: '350px' }}
        />
      </div>
      <div className={styles.actionsRow}>
        <TextField
          id="lastName"
          floatingLabelText="Last Name"
          floatingLabelFixed
          onChange={e => onChangeContactInfo('lastName', e)}
          value={lastName}
          style={{ width: '350px' }}
        />
      </div>
      <div className={styles.actionsRow}>
        <TextField
          id="email"
          floatingLabelText="Email"
          floatingLabelFixed
          onChange={e => onChangeContactInfo('email', e)}
          value={email}
          style={{ width: '350px' }}
        />
      </div>
      <div className={styles.actionsRow}>
        <TextField
          id="phoneNumber"
          floatingLabelText="Phone Number"
          floatingLabelFixed
          value={formatPhoneNumberUS(phoneNumber)}
          style={{ width: '350px' }}
        />
      </div>
      <div className={styles.actionsRow}>
        <SelectField
          id="attribution"
          autoWidth
          floatingLabelStyle={{ textJustify: 'left' }}
          floatingLabelText="How did they find us (if applicable)?"
          floatingLabelFixed
          onChange={(e, ind, val) => onDropdownSelect('attribution', val)}
          value={attribution}
          style={{ width: '350px', textAlign: 'left' }}
        >
          <MenuItem value="Doctor Referral" primaryText="Doctor Referral" />
          <MenuItem value="Patient Referral" primaryText="Patient Referral" />
          <MenuItem value="Online" primaryText="Online" />
          <MenuItem value="Other" primaryText="Other" />
        </SelectField>
      </div>
      {attribution === 'Other' &&
        <div className={styles.actionsRow}>
          <TextField
            id="otherAttribution"
            hintText="How did they find us?"
            onChange={e => onChangeContactInfo('otherAttribution', e)}
            value={otherAttribution}
            style={{ width: '350px' }}
          />
        </div>
      }
      <div className={styles.actionsRow}>
        <FlatButton
          label="Discard"
          secondary
          className={styles.deleteButton}
          onClick={onDiscardClick}
        />
        <FlatButton
          label="Save"
          primary
          onClick={onSaveClick}
          disabled={!validForm}
        />
      </div>
    </div>
  )
}

ContactInfoForm.propTypes = {
  newContactInfo: PropTypes.object.isRequired,
  onChangeContactInfo: PropTypes.func.isRequired,
  onDropdownSelect: PropTypes.func.isRequired,
  onDiscardClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
}

export default ContactInfoForm



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactPopover/ContactInfoForm.js